import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    barChart: {
      maxWidth: '480px',
      margin: 'auto',
      maxHeight: '280px',
    },
    channelSelect: {
      minWidth: '340px',
      '& > *': {
        width: '100%',
      },

      [theme.breakpoints.down('md')]: {
        minWidth: '150px',
      },
    },
    metricGridItems: {
      marginTop: theme.spacing(1),
    },
    paper: {
      boxShadow:
        '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
    },
    metricBoxChart: {
      padding: theme.spacing(2),
      height: '100%',
    },
    horizontalBarChart: {
      height: '30vh',
      width: '30vw',
      [theme.breakpoints.down('768')]: {
        height: '30vh',
        width: '70vw',
      },
    },
    activityDonutChart: {
      maxWidth: '416px',
      margin: 'auto',
    },
    bottomDashboard: {
      display: 'flex',
      flex: 1,
      justifyContent: 'space-around',
      width: '100%',
      [theme.breakpoints.down('768')]: {
        flexDirection: 'column',
        justifyContent: 'center',
      },
    },
    cardWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      fontSize: '1.2em',
    },
    cardWrapperList: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      fontSize: '1.2em',
      width: '100%',
    },
    channelView: {
      display: 'flex',
      width: 200,
      backgroundColor: 'red',
      color: 'white',
      fontSize: 20,
      flexDirection: 'row',
      justifyContent: 'space-between',
      margin: 2,
      padding: 5,
    },
    dashboard: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      padding: '2vh 2vw',
      width: '100%',
      [theme.breakpoints.down('768')]: {
        display: 'block',
      },
    },
    listView: {
      alignItems: 'center',
      flexDirection: 'column',
      height: '27vh',
      overflowY: 'scroll',
      overflowX: 'hidden',
    },
    mainBox: {
      marginTop: '1.5vh',
    },
    middleDashboard: {
      alignItems: 'center',
      display: 'flex',
      flex: 0.6,
      justifyContent: 'space-around',
      marginTop: '2vh',
      width: '100%',
      [theme.breakpoints.down('768')]: {
        flexDirection: 'column',
        justifyContent: 'center',
      },
    },
    noData: {
      alignItems: 'center',
      alignSelf: 'center',
      display: 'flex',
      flexDirection: 'column',
      height: '80vh',
      justifyContent: 'center',
      textAlign: 'center',
      width: '100%',
    },
    title: {
      fontFamily: 'Montserrat',
      fontSize: '1.4em',
      fontWeight: 'bold',
      margin: '3vh 0',
      textTransform: 'uppercase',
    },
    subtitle: {
      fontFamily: 'Montserrat',
      fontSize: '1.2em',
      fontWeight: 'bold',
      margin: '0 0 2vh',
      textTransform: 'uppercase',
    },
    toggleButton: {
      alignItems: 'center',
      background: '#353535',
      borderRadius: '50%',
      color: '#fff',
      display: 'none',
      fontSize: '15px',
      height: '35px',
      justifyContent: 'center',
      textAlign: 'center',
      width: '35px',
      [theme.breakpoints.down('768')]: {
        display: 'block',
      },
    },
    xaxis: {
      color: 'red',
    },
  })
);
